<template>
  <v-container mb-12 mt-5>
    <v-row>
      <v-col sm="3" md="4" offset-lg="0">
        <h1>Permissions</h1>
        <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <hr />
    <PermissionModal />
    <v-row>
      <v-col>
        <v-data-table
          show-select
          v-model="selected"
          :single-select="false"
          :headers="headers"
          :items="allPermissions"
          :items-per-page="5"
          class="elevation-2"
          item-key="id"
          :search="search"
        >
          <!-- <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteItem(item.id)">mdi-delete</v-icon>
          </template> -->
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PermissionModal from '../../components/PermissionCreateModal';
import Swal from 'sweetalert2';

export default {
  name: "Permissions",
  components: {
    PermissionModal,
  },
  data() {
    return {
      singleSelect: false,
      selected: [],
      search: '',
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Description", value: "description" },
        { text: "Date Created", value: "date" },
        // { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchPermissions", "deletePermission"]),
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

          this.deletePermission(id)
            .then(() => {
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
              this.fetchPermissions();
            })
        }
      })
    },
  },
  computed: mapGetters(["allPermissions"]),
  created() {
    this.fetchPermissions({ itemsPerPage: 0 });
  },
};
</script>

<style>
</style>